import { c as _c } from "react/compiler-runtime";
import { track } from "@opensea/analytics";
import { readFragment } from "@opensea/graphql";
import { Item, ItemAvatar, ItemContent, Link } from "@opensea/next-ui-kit";
import { FlexColumn, TableCell, TableRow, TextBody, TextLabel, TextOverflowTooltip } from "@opensea/ui-kit";
import { LiveTimestamp } from "@/components/activity-feed/LiveTimestamp";
import { TokenPrice } from "@/components/price/TokenPrice";
import { useNotificationsContext } from "./NotificationsContext";
import { NotificationsTableRowFragment } from "./NotificationsTableRow.fragment";
import { NotificationsTableRowSkeleton } from "./NotificationsTableRowSkeleton";
import { NOTIFICATION_TABLE_CLASSNAMES } from "./styles";
import { useNotification } from "./UseNotification";
export function NotificationsTableRow(t0) {
  const $ = _c(39);
  const {
    item: notificationKey
  } = t0;
  const {
    handleNotificationClick
  } = useNotificationsContext();
  let t1;
  if ($[0] !== notificationKey) {
    t1 = readFragment(NotificationsTableRowFragment, notificationKey);
    $[0] = notificationKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const notificationData = t1;
  const {
    href,
    isRead,
    title,
    content,
    imageUrl,
    occurredAt,
    price,
    value
  } = useNotification(notificationData);
  let t2;
  if ($[2] !== occurredAt) {
    t2 = new Date(occurredAt);
    $[2] = occurredAt;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const eventTime = t2;
  let t3;
  if ($[4] !== handleNotificationClick) {
    t3 = () => {
      track("Click Notification");
      handleNotificationClick();
    };
    $[4] = handleNotificationClick;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleLinkClick = t3;
  if (!notificationData) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <NotificationsTableRowSkeleton />;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] !== isRead) {
    t4 = isRead ? null : <div className="size-2 rounded-full bg-blue-2" />;
    $[7] = isRead;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <TableCell className={NOTIFICATION_TABLE_CLASSNAMES.unreadBadge}>{t4}</TableCell>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== imageUrl) {
    t6 = imageUrl ? <ItemAvatar className="rounded object-contain" size={32} src={imageUrl} /> : <div className="size-8 shrink-0 rounded bg-additional-2" />;
    $[11] = imageUrl;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== title) {
    t7 = <TextLabel color="text-secondary" size="xs">{title}</TextLabel>;
    $[13] = title;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== content) {
    t8 = <TextOverflowTooltip><TextBody weight="semibold">{content}</TextBody></TextOverflowTooltip>;
    $[15] = content;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <ItemContent>{t7}{t8}</ItemContent>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t9) {
    t10 = <TableCell className={NOTIFICATION_TABLE_CLASSNAMES.description}><Item variant="unstyled">{t6}{t9}</Item></TableCell>;
    $[20] = t6;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== eventTime) {
    t11 = <TextLabel className="whitespace-nowrap lowercase" color="text-secondary" size="xs"><LiveTimestamp date={eventTime} /></TextLabel>;
    $[23] = eventTime;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== price || $[26] !== value) {
    t12 = value ?? <TokenPrice className="w-full justify-end" price={price} />;
    $[25] = price;
    $[26] = value;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <TableCell className={NOTIFICATION_TABLE_CLASSNAMES.side}><FlexColumn className="items-end">{t11}{t12}</FlexColumn></TableCell>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t10 || $[32] !== t13 || $[33] !== t5) {
    t14 = <TableRow className={NOTIFICATION_TABLE_CLASSNAMES.row} interactive={true}>{t5}{t10}{t13}</TableRow>;
    $[31] = t10;
    $[32] = t13;
    $[33] = t5;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== handleLinkClick || $[36] !== href || $[37] !== t14) {
    t15 = <Link href={href} onClick={handleLinkClick} variant="unstyled">{t14}</Link>;
    $[35] = handleLinkClick;
    $[36] = href;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
}